module.exports = __webpack_public_path__ + "img/Lab Book Icon_Over.652d00ff.svg";